module.exports = __webpack_public_path__ + "lt.bc425441.svg";